// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';

type Props = {
  width?: number;
  fill?: string;
};
export const Collection = ({ fill = 'none', width = 16 }: Props) => {
  const { colorMode } = useColorMode();
  const fillColor = colorMode === 'light' ? 'black' : 'none';
  return (
    <chakra.svg
      height={`${width}px`}
      width={`${width}px`}
      fill={fillColor}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      cursor="pointer"
    >
      <path
        d="M9.56687 2.91617C9.60212 2.8302 9.66214 2.75665 9.73931 2.70489C9.81647 2.65313 9.90729 2.62549 10.0002 2.62549C10.0931 2.62549 10.1839 2.65313 10.2611 2.70489C10.3383 2.75665 10.3983 2.8302 10.4335 2.91617L12.2044 7.17534C12.2375 7.25504 12.292 7.32404 12.3619 7.37477C12.4317 7.42549 12.5142 7.45597 12.6002 7.46284L17.1985 7.83118C17.6144 7.86451 17.7827 8.38368 17.466 8.65451L13.9627 11.6562C13.8973 11.7122 13.8485 11.7851 13.8217 11.867C13.795 11.9488 13.7913 12.0365 13.811 12.1203L14.8819 16.6078C14.9034 16.6979 14.8978 16.7923 14.8657 16.8791C14.8336 16.9659 14.7765 17.0413 14.7016 17.0957C14.6267 17.1501 14.5373 17.1811 14.4448 17.1847C14.3523 17.1883 14.2608 17.1645 14.1819 17.1162L10.2444 14.712C10.1708 14.6672 10.0863 14.6435 10.0002 14.6435C9.91407 14.6435 9.82959 14.6672 9.75604 14.712L5.81854 17.117C5.73959 17.1653 5.64809 17.1892 5.55559 17.1855C5.46309 17.1819 5.37375 17.1509 5.29885 17.0965C5.22394 17.0421 5.16684 16.9668 5.13475 16.8799C5.10266 16.7931 5.09702 16.6987 5.11854 16.6087L6.18937 12.1203C6.20923 12.0365 6.20558 11.9488 6.17882 11.8669C6.15207 11.785 6.10324 11.7121 6.03771 11.6562L2.53437 8.65451C2.46422 8.59418 2.41347 8.51446 2.3885 8.42537C2.36353 8.33628 2.36546 8.24179 2.39405 8.1538C2.42264 8.0658 2.47661 7.98822 2.54918 7.93082C2.62174 7.87341 2.70966 7.83875 2.80187 7.83118L7.40021 7.46284C7.48625 7.45597 7.56873 7.42549 7.63856 7.37477C7.7084 7.32404 7.76289 7.25504 7.79604 7.17534L9.56687 2.91617Z"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </chakra.svg>
  );
};
